import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import AppknoxConfigListing from './AppknoxConfigListing'
import AppknoxCredentialsForm from './AppknoxCredentialsForm'

export default function AppknoxPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={AppknoxCredentialsForm}
            PullConfigListingView={AppknoxConfigListing}
        />
    )
}
